
import styled from 'styled-components';
import { SectionIntroProps } from './query';
import Button_v2 from '@/components/molecules/Button/index';
import Title_v2 from '@/components/molecules/Title/index';
import { AppStoreButton } from '@/components/styled';
import HalfSplitWithImage from '@/components/wrappers/HalfSplitWithImage';
import { AppleStore, GooglePlay } from '@/public/img/icons';
import devices from '@/utilities/devices';
import { renderUnderline } from '@/utilities/functions';

// #region STYLE
const Description = styled.h3`
	font-size: ${({ theme }) => theme.fontSize.DEFAULT};
	font-weight: normal;
	padding-top: 1.1rem;

	@media screen and (${devices.mobile}) {
		padding: .5rem 0rem;
		text-align: center;
	}

	@media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
		padding: .5rem 2rem;
		text-align: center;
	}
`;

const AppStoreContainer = styled.div`
	display: flex;
	margin-top: 1rem;
	margin-bottom: 2.8rem;
	a:first-child {
		margin-right: 1rem;
	}
	@media screen and (${devices.mobile}) {
		margin-bottom: 1rem;
	}
	@media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
		margin-bottom: 1rem;
	}
`;

const MobileHeroImageContainer = styled.div<{ backgroundImage: string }>`
	background-image: url(${({ backgroundImage }) => backgroundImage});
	background-position: center;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 7px;
	display: none;
	margin: 1rem 0;
	position: relative;
	@media screen and (${devices.mobile}) {
		display: block;
		width: 100%;
		height: 220px;
	}

	@media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
		display: block;
		width: 100%;
		height: 350px;
	}
`;
// #endregion

const SectionIntro = ({ sectionIntroData, children }: {
	sectionIntroData: SectionIntroProps;
	children?: any;
}) => {

	const GooglePlayLink = 'https://app.adjust.com/mhrod40?label=Playstore&redirect=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dbruce.team';
	const AppleStoreLink = 'https://app.adjust.com/e3j5vyq?redirect=https%3A%2F%2Fapps.apple.com%2Ffr%2Fapp%2Fbruce-offres-demploi%2Fid1062629311';

	return (
		<>
			<HalfSplitWithImage
				alt={sectionIntroData.imageDesktop.data.attributes.alternativeText}
				backgroundUrl={sectionIntroData.imageDesktop.data.attributes.url}
			>
				<Title_v2
					align={sectionIntroData.title.alignedAt}
					white
					padding='0 4rem 0 0'
					underlineColor={sectionIntroData.title.underlineColor}
				>
					{renderUnderline(sectionIntroData.title.titlePieces)}
				</Title_v2>
				<MobileHeroImageContainer backgroundImage={sectionIntroData.imageMobile.data.attributes.url} />
				{sectionIntroData.description && <Description> {sectionIntroData.description} </Description>}
				{sectionIntroData.showAppStoreButtons && (
					<AppStoreContainer>
						<AppStoreButton href={AppleStoreLink}> <AppleStore /> </AppStoreButton>
						<AppStoreButton href={GooglePlayLink}> <GooglePlay /> </AppStoreButton>
					</AppStoreContainer>
				)}
				{children}
				{
					sectionIntroData.buttons.map(
						(button, index) => (
							<Button_v2
								gtm_id={button.trackerId}
								href={button.url}
								key={index}
								margin={{ top: '1.5rem' }}
								openOnNewTab={button.newTab}
								text={button.text}
								version={button.variant}
							/>
						),
					)
				}
			</HalfSplitWithImage>
		</>
	);
};

export default SectionIntro;
